import { useCallback, useEffect, useState } from 'react';

import { getFallEvents, updateFallEvent } from '../../services/fallEventService';

const normaliseResponse = (data) => {
  if (!data) return [];
  if (Array.isArray(data.results)) return data.results;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
};

const useClientFallEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [updating, setUpdating] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getFallEvents();
      setEvents(normaliseResponse(data));
    } catch (err) {
      setError('Unable to load fall events.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const saveEvent = useCallback(async (eventId, payload) => {
    setUpdating(true);
    setError('');
    try {
      const updated = await updateFallEvent(eventId, payload);
      setEvents((prev) => prev.map((event) => (event.id === eventId ? { ...event, ...updated } : event)));
      return updated;
    } catch (err) {
      setError('Unable to update fall event.');
      throw err;
    } finally {
      setUpdating(false);
    }
  }, []);

  return {
    events,
    loading,
    error,
    updating,
    refresh,
    saveEvent,
    setEvents,
    setError,
    setUpdating,
  };
};

export default useClientFallEvents;
